'use strict';
import angular from 'angular';
import tiktokGeoTargetingHtmlUrl from './views/tiktokAdsGeoLocation.list.html';
var app = angular.module('app.tiktokGeoTargeting.component', []);
app.component('tiktokGeoTargeting', {
  bindings: {
    selectedTiktokGeoLocations : '=',
    clusterId : '=',
    showActions : '=',
    isFormEdit: '=',
    clientId: '='
  },
  templateUrl: tiktokGeoTargetingHtmlUrl,
  controller: function($scope,$ioAlert, anchorSmoothScroll, $location, $timeout,$stateParams,FormService,ClusterService) {
    var self = this;
    self.orderId = $stateParams.orderId;
    self.rootLocation = { "id": 0, "children": "1", "criteria": "" };
    self.navTiktokLocations = [];
    self.previousLocationData = [];
    self.geolocSearch = "";
    self.breadcrumbs = [];
    self.collectedNodes = [0];
    self.includeOrExcludeLocation = null;
    var geoLocationsCount = 0;
    self.selectedListOfLocations = [];
    self.showTabPanel = true;
    self.selectedInput = {
      value: 'tiktok_locations'
    }
    self.geoTextInputs = {
      inputValues: ''
    }
    self.textInputOptions = ["US Postal Codes", "US States", "US Cities"];
    self.textInputObj = {
      textInputType: "US Postal Codes"
    }
    self.selectedCriteria = {
      criteria: ""
    };
    self.criteria = ["include all", "exclude all"];
    self.showError = false;
    self.toggleComponent = function(selectedOption) {
      self.selectedInput.value = selectedOption;
    }
    $scope.$watch('$ctrl.geoTextInputs.inputValues', function() {
      if(self.geoTextInputs.inputValues.length == 0) {
        self.showError = false;
      }
    });
    $scope.$watchCollection('$ctrl.selectedTiktokGeoLocations.selTiktokLocationPickers', function (newCol, oldCol, scope) {
      _.map(newCol, function (item) {
        item.selectedInput = "tiktok_textInput";
        self.selectedListOfLocations.push(item)
      })
      self.selectedListOfLocations  = _.uniq(self.selectedListOfLocations, 'id');
    })
    $scope.$watchCollection('$ctrl.selectedTiktokGeoLocations.selTiktokTextInputs', function (newCol, oldCol, scope) {
      _.map(newCol, function (item) { self.selectedListOfLocations.push(item) })
      self.selectedListOfLocations = _.uniq(self.selectedListOfLocations, 'id');
    })
    self.handleChangeTextInput = function() {
      self.geoTextInputs.inputValues = '';
      self.showError = false;
    }
    /*
    * Handle validate postal codes
    */
    self.validateInputValues = function () {
      if (self.textInputObj.textInputType == "US Postal Codes") {
        var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
        var type = "postal_code"
        var filteredValues = geoValues.filter(function (el) {
          return el != "";
        });
        FormService.validateTiktokGeo(filteredValues,self.clientId,self.clusterId,type,'validate_city_region_postal').then(function (data) {
          if (data) {
            processTextInputs(data);
          }
        }, function (error) {
          $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
        });
      } else if (self.textInputObj.textInputType == "US States") {
        var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
        var type = "region";
        var filteredValues = geoValues.filter(function (el) {
          return el != "";
        });
        FormService.validateTiktokGeo(filteredValues,self.clientId,self.clusterId, type,'validate_city_region_postal').then(function (data) {
          if (data) {
            processTextInputs(data);
          }
        }, function (error) {
          $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
        });
      } else if (self.textInputObj.textInputType == "US Cities") {
        var geoValues = self.geoTextInputs.inputValues.replace(/\n/g, ",").split(",");
        var type = "city"
        var filteredValues = geoValues.filter(function (el) {
          return el != "";
        });
        FormService.validateTiktokGeo(filteredValues,self.clientId,self.clusterId,type,'validate_city_region_postal').then(function (data) {
          if (data) {
            processTextInputs(data);
          }
        }, function (error) {
          $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again ', 'error');
        });
      }
    }
    /*
    * Handle process GET response
    */
    var processTextInputs = function(response) {
      if(response.valid && response.valid.length > 0) {
        _.each(response.valid, function(validGeoValue) {
          validGeoValue.geoType = self.textInputObj.textInputType;
          validGeoValue.criteria_link = 'included';
          self.selectedTiktokGeoLocations.selTiktokTextInputs.push(validGeoValue);
        })
        self.geoTextInputs.inputValues = '';
      }
      if(response.invalid && response.invalid.length > 0){
        self.showError = true;
        self.geoTextInputs.inputValues = response.invalid.toString();
      }
    }
    self.getPostalCodesTooltips=function(selTiktokTextInputs){
      var data = angular.copy(selTiktokTextInputs);
      data = data.slice(5);
      var html=angular.element("<ul/>");
      angular.forEach(data,function(item){
        var li = angular.element("<li style='list-style:none;'/>");
        li.text(item.name);
        html.append(li);
      });
      return html.html();
    };
    self.getLocationTooltips=function(locations){
      var data = angular.copy(locations);
      data = data.slice(2);
      var html=angular.element("<ul/>");
      angular.forEach(data,function(item){
        var li = angular.element("<li style='list-style:none;'/>");
        li.text(item.full_name);
        html.append(li);
      });
      return html.html();
    };
    /*
    * Handle remove selected text inputs
    */
    self.removeTextInputs = function(removeItem) {
      var selIndex = _.findIndex(self.selectedTiktokGeoLocations.selTiktokTextInputs, {external_id: removeItem.external_id});
      if (selIndex >= 0) {
        self.selectedTiktokGeoLocations.selTiktokTextInputs.splice(selIndex, 1);
      }
    }
    /*
    * Handle Clear All Text Inputs
    */
    self.handleClearAllInputs = function() {
      self.selectedTiktokGeoLocations.selTiktokTextInputs = [];
    }
    self.handleClearSelectedLocations = function() {
      self.selectedTiktokGeoLocations.selTiktokLocationPickers = [];
      self.selectedTiktokGeoLocations.selTiktokTextInputs = [];
      self.selectedListOfLocations = [];
      self.selectedCriteria.criteria = 'none';
      geoLocationsCount = 0;
      self.includeOrExcludeLocation = null;
      _.each(self.navTiktokLocations, function(navLocation) {
        navLocation.criteria = '';
        navLocation.criteria_link = 'include';
      });
    }
    self.handleChangeCriteria = function() {
      self.selectedTiktokGeoLocations.selTiktokLocationPickers = [];
      if(self.selectedCriteria.criteria == 'include all') {
        _.each(self.navTiktokLocations, function(navLocation) {
          navLocation.criteria = 'include';
          navLocation.criteria_link = 'included';
          navLocation.full_name = self.buildFullName(navLocation);
          self.selectedTiktokGeoLocations.selTiktokLocationPickers.push(navLocation);
        });
      } else if(self.selectedCriteria.criteria == 'exclude all') {
        _.each(self.navTiktokLocations, function(navLocation) {
          navLocation.criteria = 'exclude';
          navLocation.criteria_link = 'excluded';
          navLocation.full_name = self.buildFullName(navLocation);
          self.selectedTiktokGeoLocations.selTiktokLocationPickers.push(navLocation);
        });
      } else {
        _.each(self.navTiktokLocations, function(navLocation) {
          navLocation.criteria = '';
          navLocation.criteria_link = 'include';
        });
      }
    }
    self.getChildrenNodes = function(item) {
      if (item.children > 0) {
        self.getLocationChilds(item);
        self.geolocSearch = "";
      }
    };
    self.showtabPanel = function() {
      self.showTabPanel = !self.showTabPanel;
    }
    self.getLocationChilds = function(item) {
      if (item.children > 0) {
        self.navTiktokLocations = [];
        if (self.locations) {
          for (var i = 0, len = self.locations.length; i < len; i++) {
            if (self.locations[i].parent_id == item.id) {
              if (self.selectedTiktokGeoLocations.selTiktokLocationPickers.length > 0) {
                var selIndex = _.findIndex(self.selectedTiktokGeoLocations.selTiktokLocationPickers, { id: self.locations[i].id });
                if (selIndex !== -1) {
                  self.locations[i].criteria = self.selectedTiktokGeoLocations.selTiktokLocationPickers[selIndex].criteria;
                  self.includeOrExcludeLocation = self.selectedTiktokGeoLocations.selTiktokLocationPickers[selIndex].criteria + 'location';
                }
              } else{
                self.locations[i].criteria = "";
              }
              if (self.locations[i].criteria.length == 0 && item.criteria.length > 0) {
                self.locations[i].criteria = item.criteria;
              }
              self.locations[i].criteria_link = 'include';
              if (self.locations[i].criteria == "include") {
                self.locations[i].criteria_link = 'included';
              } else if (self.locations[i].criteria == "exclude") {
                self.locations[i].criteria_link = 'excluded';
              }
              self.navTiktokLocations.push(self.locations[i]);
              self.checkingCriteria();
            }
          }
          self.navTiktokLocations.sort(function(a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
          });
          self.previousLocationData = angular.copy(self.navTiktokLocations);
        }
        self.breadcrumbs = [];
        self.buildBreadcrumbs(item);
      }
    }
    self.changeIncludeExclude = function(item, criteria) {
      var index = self.navTiktokLocations.indexOf(item);
      if (index >= 0) {
        if (criteria == "include") {
          self.navTiktokLocations[index].criteria = 'include';
          self.navTiktokLocations[index].criteria_link = 'included';
        } else if (criteria == "exclude") {
          self.navTiktokLocations[index].criteria = 'exclude';
          self.navTiktokLocations[index].criteria_link = 'excluded';
        } else {
          self.navTiktokLocations[index].criteria = '';
          self.navTiktokLocations[index].criteria_link = 'include';
        }
        if(geoLocationsCount < 1) {
          self.includeOrExcludeLocation = criteria + 'location';
        }
        var selIndex = _.findIndex(self.selectedTiktokGeoLocations.selTiktokLocationPickers, { id: self.navTiktokLocations[index].id });
        self.navTiktokLocations[index].full_name = self.buildFullName(self.navTiktokLocations[index])
        if (selIndex >= 0) {
          self.selectedTiktokGeoLocations.selTiktokLocationPickers[selIndex] = self.navTiktokLocations[index];
        } else {
          self.selectedTiktokGeoLocations.selTiktokLocationPickers.push(self.navTiktokLocations[index]);
        }
        changeAllChildCriteria(self.navTiktokLocations[index].id, self.navTiktokLocations[index].criteria);
        for(var i=0; i<self.selectedTiktokGeoLocations.selTiktokLocationPickers.length; i++){
          var parentId = parseInt(self.selectedTiktokGeoLocations.selTiktokLocationPickers[i].parent_id);
          var parentObj = _.find(self.locations, {id: parentId});
          if(parentObj && parentObj.criteria === self.selectedTiktokGeoLocations.selTiktokLocationPickers[i].criteria ){
            self.selectedTiktokGeoLocations.selTiktokLocationPickers.splice(i, 1);
          }
        }
        geoLocationsCount++;
      }
    }
    self.removeLoc = function (item) {
      if (item.selectedInput == "tiktok_textInput") {
        var selIndex = self.selectedTiktokGeoLocations.selTiktokLocationPickers.indexOf(item);
        self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
        if (selIndex >= 0) {
          self.selectedTiktokGeoLocations.selTiktokLocationPickers.splice(selIndex, 1);
          if (self.selectedTiktokGeoLocations.selTiktokLocationPickers.length == 0) {
            geoLocationsCount = 0;
            self.includeOrExcludeLocation = null;
          }
        }
        var parentId = parseInt(item.parent_id);
        var parentLocation = _.find(self.locations, { id: parentId });
        var locationObj = _.find(self.locations, { id: item.id });
        if (locationObj) {
          if (parentLocation) {
            if (parentLocation.criteria == "include") {
              locationObj.criteria = 'include';
              locationObj.criteria_link = 'included';
            } else if (parentLocation.criteria == "exclude") {
              locationObj.criteria = 'exclude';
              locationObj.criteria_link = 'excluded';
            } else {
              locationObj.criteria = '';
              locationObj.criteria_link = 'include';
            }
          } else {
            locationObj.criteria = '';
            locationObj.criteria_link = 'include';
            for (var k = 0; k < self.navTiktokLocations.length; k++) {
              if (self.navTiktokLocations[k].name == item.name) {
                self.navTiktokLocations[k].criteria = '';
                self.navTiktokLocations[k].criteria_link = 'include';
                break;
              }
            }
            self.previousLocationData = angular.copy(self.navTiktokLocations);
          }
          changeAllChildCriteria(item.id, locationObj.criteria);
        } else {
          for (var k = 0; k < self.navTiktokLocations.length; k++) {
            if (self.navTiktokLocations[k].name == item.name) {
              self.navTiktokLocations[k].criteria = '';
              self.navTiktokLocations[k].criteria_link = 'include';
              break;
            }
          }
        }
        for (var i = 0; i < self.selectedTiktokGeoLocations.selTiktokLocationPickers.length; i++) {
          if (self.selectedTiktokGeoLocations.selTiktokLocationPickers[i].parent_id == String(item.id)) {
            self.selectedTiktokGeoLocations.selTiktokLocationPickers.splice(i, 1);
          }
        }
      } else {
        var selIndex = _.findIndex(self.selectedTiktokGeoLocations.selTiktokTextInputs, {id: item.id});
        if (selIndex >= 0) {
          self.selectedTiktokGeoLocations.selTiktokTextInputs.splice(selIndex, 1);
          self.selectedListOfLocations.splice(self.selectedListOfLocations.indexOf(item),1)
        }
      }
    }
    function changeAllChildCriteria(parentId, criteria = ""){
      _.each(self.locations, function(location){
        if(location.parent_id==parentId){
          if(criteria == "include"){
            location.criteria = 'include';
            location.criteria_link = 'included';
          }else if(criteria == "exclude"){
            location.criteria = 'exclude';
            location.criteria_link = 'excluded';
          }else{
            location.criteria = '';
            location.criteria_link = 'include';
          }
          changeAllChildCriteria(location.id, location.criteria);
        }
      });
    }

    self.searchTiktokLocation = function(geolocSearch) {
      if (event.keyCode != 13) {
        if (geolocSearch.length > 0) {
          const filteredData = self.locations.filter(item =>
            item.name.toLowerCase().includes(geolocSearch.toLowerCase())
          );
          processData(filteredData);
        } else {
          // empty search, restore previous locations
          self.navTiktokLocations = angular.copy(self.previousLocationData);
          self.checkingCriteria();
        }
      }

      function processData(data) {
        self.navTiktokLocations = angular.copy(data);
        self.checkingCriteria();
      }
    };

    self.checkingCriteria = function(){
      for(var k=0;k<self.selectedTiktokGeoLocations.selTiktokLocationPickers.length;k++){
        for(var j=0;j<self.navTiktokLocations.length;j++){
          if(self.selectedTiktokGeoLocations.selTiktokLocationPickers[k].id == self.navTiktokLocations[j].id){
            if (self.selectedTiktokGeoLocations.selTiktokLocationPickers[k].criteria == "include") {
              self.navTiktokLocations[j].criteria = 'include';
              self.navTiktokLocations[j].criteria_link = 'included';
            } else if (self.selectedTiktokGeoLocations.selTiktokLocationPickers[k].criteria == "exclude") {
              self.navTiktokLocations[j].criteria = 'exclude';
              self.navTiktokLocations[j].criteria_link = 'excluded';
            }else{
              self.navTiktokLocations[j].criteria = '';
              self.navTiktokLocations[j].criteria_link = 'include';
            }
          }
        }
      }
    }
    self.buildBreadcrumbs = function(item) {
      if (item.parent_id || item.parent_id == 0) {
        self.breadcrumbs.unshift(item);
        if (item.parent_id == 0) {
          return false;
        } else {
          var obj = _.find(self.locations, function(loc) {
            return loc.id == item.parent_id
          });
          self.buildBreadcrumbs(obj);
        }
      }
    }
    self.buildFullName = function(item) {
      if (item.parent_id == 0) {
        return item.name + ".";
      } else {
        var obj = _.find(self.locations, function(loc) {
          return loc.id == item.parent_id
        });
        if(obj == undefined && item.parent_name){
          return item.name + " , " + item.parent_name +"."
        } else {
          return item.name + ", " + self.buildFullName(obj);
        }
      }
    }
    var getLocations = function() {
      FormService.getTiktokGeoLocations(self.clientId,self.clusterId,"NA",'get_locations').then(function(success) {
        self.locations = success;
        self.childrenCountMap = {};
        self.locations.forEach(function(loc) {
          if (loc.parent_id) {
            self.childrenCountMap[loc.parent_id] = (self.childrenCountMap[loc.parent_id] || 0) + 1;
          }
        });
        self.getLocationChilds(self.rootLocation);
      }, function(error) {
        $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
      });
    };
    var initLocations = function() {
      if(self.selectedTiktokGeoLocations && !_.isEmpty(self.selectedTiktokGeoLocations)){
        self.selectedTiktokGeoLocations = JSON.parse(self.selectedTiktokGeoLocations);
        if(self.showActions) {
          self.editMode = true;
          self.enableViewMode = false;
          getLocations();
          if(self.selectedTiktokGeoLocations.selTiktokTextInputs && self.selectedTiktokGeoLocations.selTiktokTextInputs.length > 0){
            self.textInputObj.textInputType = self.selectedTiktokGeoLocations.selTiktokTextInputs[0].geoType ? self.selectedTiktokGeoLocations.selTiktokTextInputs[0].geoType : "US Postal Codes";
          }
        } else {
          self.editMode = false;
          self.enableViewMode = true;
        }
      } else {
        self.selectedTiktokGeoLocations = {
          selTiktokLocationPickers: [],
          selTiktokTextInputs: []
        };
        self.enableViewMode = false;
        self.editMode = false;
        getLocations();
      }
    };
    initLocations();
  }
});
